// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import Vue from 'vue';
import { Servicelayer } from '@glittr/frontend-core/src/plugins/servicelayer';
import RequestConfig from '@glittr/frontend-core/src/plugins/servicelayer/requestConfig';
import GetIntegrationCallOverviewRequestViewModel from '../../viewModel/request/IntegrationCalls/GetIntegrationCallOverviewRequestViewModel';
import GetIntegrationCallsRequestViewModel from '../../viewModel/request/IntegrationCalls/GetIntegrationCallsRequestViewModel';
import GetIntegrationCallStepsByCallIdRequestViewModel from '../../viewModel/request/IntegrationCalls/GetIntegrationCallStepsByCallIdRequestViewModel';
import DownloadIntegrationCallReportRequestViewModel from '../../viewModel/request/IntegrationCalls/DownloadIntegrationCallReportRequestViewModel';
import IntegrationCallStateOverviewResourceListResultViewModel from '../../viewModel/resource/IntegrationCallStateOverviewResourceListResultViewModel';
import IntegrationCallListResourcePagingResultViewModel from '../../viewModel/resource/IntegrationCallListResourcePagingResultViewModel';
import IntegrationCallResourceViewModel from '../../viewModel/resource/IntegrationCallResourceViewModel';
import IntegrationCallStepResourcePagingResultViewModel from '../../viewModel/resource/IntegrationCallStepResourcePagingResultViewModel';
import CompleteIntegrationCallRequestViewModel from '../../viewModel/resource/CompleteIntegrationCallRequestViewModel';
import ReExecuteIntegrationCallRequestViewModel from '../../viewModel/resource/ReExecuteIntegrationCallRequestViewModel';

export default (service: Servicelayer) => ({
  /**  */
  async getIntegrationCallOverview(request: GetIntegrationCallOverviewRequestViewModel, config?: RequestConfig) {
    const requestDTO = request.toDTO();
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-integration-call-overview'] ?? 'core/integration/IntegrationCalls/Overview';
    const response = await service.get<any>(endpointPath, {
      query: {
        from: requestDTO.from,
        to: requestDTO.to,
      },
      ...config,
    });
    const dto = response.data.result;
    return new IntegrationCallStateOverviewResourceListResultViewModel().fromDTO(dto);
  },
  /**  */
  async getIntegrationCalls(request: GetIntegrationCallsRequestViewModel, config?: RequestConfig) {
    const requestDTO = request.toDTO();
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-integration-calls'] ?? 'core/integration/IntegrationCalls';
    const response = await service.get<any>(endpointPath, {
      query: {
        dateFrom: requestDTO.dateFrom,
        dateTo: requestDTO.dateTo,
        integrationTaskId: requestDTO.integrationTaskId,
        integrationStatusId: requestDTO.integrationStatusId,
        correlationId: requestDTO.correlationId,
        appTransactionId: requestDTO.appTransactionId,
        appUserId: requestDTO.appUserId,
        searchCriteria: requestDTO.searchCriteria,
        'paging.CurrentPage': requestDTO['paging.CurrentPage'],
        'paging.PageSize': requestDTO['paging.PageSize'],
        'paging.IncludeCount': requestDTO['paging.IncludeCount'],
        'paging.NoPaging': requestDTO['paging.NoPaging'],
      },
      ...config,
    });
    const dto = response.data.result;
    return new IntegrationCallListResourcePagingResultViewModel().fromDTO(dto);
  },
  /**  */
  async getIntegrationCallById(id: number, config?: RequestConfig) {
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-integration-call-by-id'] ?? 'core/integration/IntegrationCalls/{id}';
    endpointPath = endpointPath.replace(/\{id\}/g, `${id}`);
    const response = await service.get<any>(endpointPath, {
      ...config,
    });
    const dto = response.data.result;
    return new IntegrationCallResourceViewModel().fromDTO(dto);
  },
  /**  */
  async getIntegrationCallStepsByCallId(id: number, request: GetIntegrationCallStepsByCallIdRequestViewModel, config?: RequestConfig) {
    const requestDTO = request.toDTO();
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-integration-call-steps-by-call-id'] ?? 'core/integration/IntegrationCalls/{id}/steps';
    endpointPath = endpointPath.replace(/\{id\}/g, `${id}`);
    const response = await service.get<any>(endpointPath, {
      query: {
        runNo: requestDTO.runNo,
      },
      ...config,
    });
    const dto = response.data.result;
    return new IntegrationCallStepResourcePagingResultViewModel().fromDTO(dto);
  },
  /**  */
  async completeIntegrationCall(id: number, model: CompleteIntegrationCallRequestViewModel, config?: RequestConfig) {
    const modelDTO = model.toDTO();
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-complete-integration-call'] ?? 'core/integration/IntegrationCalls/{id}/Complete';
    endpointPath = endpointPath.replace(/\{id\}/g, `${id}`);
    const response = await service.post<any>(endpointPath, {
      body: modelDTO,
      ...config,
    });
    const result = response?.data?.result ?? response?.data;
    return result as number | undefined;
  },
  /**  */
  async reExecuteIntegrationCall(id: number, model: ReExecuteIntegrationCallRequestViewModel, config?: RequestConfig) {
    const modelDTO = model.toDTO();
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-re-execute-integration-call'] ?? 'core/integration/IntegrationCalls/{id}/ReExecute';
    endpointPath = endpointPath.replace(/\{id\}/g, `${id}`);
    const response = await service.post<any>(endpointPath, {
      body: modelDTO,
      ...config,
    });
    const result = response?.data?.result ?? response?.data;
    return result as number | undefined;
  },
  /**  */
  async downloadIntegrationCallReport(request: DownloadIntegrationCallReportRequestViewModel, config?: RequestConfig) {
    const requestDTO = request.toDTO();
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-download-integration-call-report'] ?? 'core/integration/IntegrationCalls/DownloadIntegrationCallReport';
    const response = await service.get<any>(endpointPath, {
      responseType: 'blob',
      query: {
        dateFrom: requestDTO.dateFrom,
        dateTo: requestDTO.dateTo,
        customerName: requestDTO.customerName,
        taskId: requestDTO.taskId,
        integrationStatusId: requestDTO.integrationStatusId,
        searchCriteria: requestDTO.searchCriteria,
      },
      ...config,
    });
    const result = response?.data?.result ?? response?.data;
    return new Blob([result], { type: 'application/octet-stream' });
  },
});
